module.exports = __webpack_public_path__ + "img/color-palette.7e621b3c.svg";